// extracted by mini-css-extract-plugin
module.exports = {"page":"Global_page__Qe_pn","card-grid":"Global_card-grid__iCcKV"};